<mat-form-field floatLabel="always">
    <mat-label
        >{{ Label }}<span *ngIf="Required" class="required">*</span></mat-label
    >
    <mat-chip-listbox
        #peopleChipList
        multiple
        [formControl]="TagControl"
        [selectable]="selectable"
    >
        <mat-chip-option
            *ngFor="let user of selectedUsers"
            [removable]="removable"
            (removed)="remove(user)"
        >
            {{ user.displayName }}
            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
        </mat-chip-option>
        <input
            #peoplePickerInput
            matInput
            [formControl]="InputControl"
            [matAutocomplete]="auto"
            [matChipInputFor]="peopleChipList"
        />
        <mat-icon matSuffix>search</mat-icon>
    </mat-chip-listbox>
    <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayFn"
        autoActiveFirstOption
    >
        <mat-option *ngFor="let option of matches | async" [value]="option">
            {{ option.displayName }} &lt;{{ option.upn }}&gt;
        </mat-option>
    </mat-autocomplete>
</mat-form-field>
